import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../components/shared/page-components/LoadingPage';
import TaxLotsPage from '../../components/tax-lots/TaxLotsPage';
import { isModuleEnabled } from '../../data/app-config/configs/configUtilities';
import { taxLotsSearchSchema } from '../-taxLotsParamsSchema';

function AppTaxLots() {
  const transactionsEnabled = isModuleEnabled({ moduleName: 'transactions' });

  if (transactionsEnabled) {
    return <TaxLotsPage />;
  }

  return null;
}

export const Route = createFileRoute('/_authenticated/tax-lots')({
  component: AppTaxLots,
  validateSearch: (search) => {
    const parsed = taxLotsSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    configPageId: 'tax-lots',
    meta: {
      title: 'Tax Lots | Ledgible',
    },
  },
});
